import React, { createContext } from "react";
import {
  FiltersSlice,
  GetSignalsRequest,
  QueryStatus,
  Signal,
} from "@shared/types";
import { SignalsStatusValueType } from "@shared/features/signals/common/types";

interface SignalsPageContextValue {
  isOpen: boolean;
  signalsStatus: SignalsStatusValueType;
  setSignalStatus: (signalsStatus: SignalsStatusValueType) => void;
  subGroupId: number | undefined;
  isAdminSignals: boolean;
  tabToCount: Record<SignalsStatusValueType, number | undefined>;
  setTabToCount: React.Dispatch<
    React.SetStateAction<Record<SignalsStatusValueType, number | undefined>>
  >;
  signalsData: Signal[] | undefined;
  getSignalsDataQuery: QueryStatus;
  filtersSlice: FiltersSlice;
  args: GetSignalsRequest | undefined;
  isSignalsFetching: boolean;
  isSignalsLoading: boolean;
  showEmpty: boolean;
  getGroupsDataStatus: QueryStatus;
  getAdminSubGroupsStatus: QueryStatus;
}

export const SignalsPageContext = createContext<
  SignalsPageContextValue | undefined
>(undefined);
